import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const SuperCardDetails = lazy(() => import("containers/SuperCardDetails"));

import "styles/global.scss";
import { useTransaction } from "./context/TransactionContext";
import { getBridgeData, getUserDetailsFromBridge } from "./services/bridgeData";

const App = () => {
  const { setUserDetails } = useTransaction();

  useEffect(() => {
    const bridgeData = getBridgeData();
    const userDetails = getUserDetailsFromBridge(bridgeData);

    if (userDetails) {
      setUserDetails(userDetails);
    }

    if (bridgeData) {
      window.contextDetails = bridgeData;
    }
  }, [setUserDetails]);

  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/super-card-details" element={<SuperCardDetails />} />
          <Route path="/" element={<SuperCardDetails />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
